import SideMenu from './SideMenu';

const initSideMenu = () => {
  let sideMenuNode = document.getElementById('side-menu');
  if(sideMenuNode) {
    new SideMenu(sideMenuNode);
  }
}

initSideMenu();


// WEBPACK FOOTER //
// ../w-theme/ui/assets/js/components/SideMenu/init.js